import * as React from "react"
import { MDXProvider } from "@mdx-js/react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import * as StyledComponents from "./etc"

const components = {
  Link,
  ...StyledComponents
}

export default function Layout({children, location}) {
  const data = useStaticQuery(graphql`
    query {
      allMdx(sort: {frontmatter: {order: ASC}}) {
        nodes {
          frontmatter {
            title
          }
          id
          parent {
            ... on File {
              name
            }
          }
        }
      }
    }
  `)

  return (
    <MDXProvider components={components}>
      <div className="container mx-auto text-lg px-4 pt-4 pb-8 lg:pt-8 lg:pb-12">
        <header className="flex flex-col md:flex-row gap-4 lg:gap-6 mb-4">
          <div className="relative">
            <div className="w-6 lg:w-8 2xl:w-10 absolute z-50 top-1 lg:top-2 left-1 lg:left-2">
              <div className="h-3 lg:h-4 2xl:h-5 bg-blue-500 rounded-t-full"></div>
              <div className="h-3 lg:h-4 2xl:h-5 bg-yellow-400 rounded-b-full"></div>
            </div>
            <Link className="group flex items-center" to="/">
              <div className="w-28 lg:w-50 2xl:w-60">
                <StaticImage className="h-24 w-24 lg:h-36 lg:w-36 2xl:h-44 2xl:w-44 rounded-full transition-all group-hover:brightness-110" alt="Photo of me" src="../media/photo.jpg"
              />
              </div>
              <h1 className="basis-0 xl:basis-auto text-3xl 2xl:text-4xl font-semibold border-b border-gray-200 group-hover:border-gray-600 group-hover:text-gray-700 transition-all">Kostya Cherepovskyi</h1> 
            </Link>
          </div>

          <div className="flex items-center md:ml-auto gap-4 md:gap-6 lg:gap-8 text-md 2xl:text-xl">
            <a className="truncate text-blue-600 border-b border-blue-200 hover:border-blue-600 transition-all" href="mailto:kcherepovskyi@gmail.com">kcherepovskyi@gmail.com</a>
            <a href="https://www.linkedin.com/in/kostyacherepovskyi/" alt="Linkedin">
              <svg className="hover:opacity-90 transition-all" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.829 0H2.17099C0.972 0 0 0.972 0 2.17099V21.8289C0 23.028 0.972 24 2.17099 24H21.8289C23.028 24 24 23.028 24 21.8289V2.17099C24 0.972 23.028 0 21.829 0ZM7.42662 20.7232C7.42662 21.0721 7.14377 21.355 6.79483 21.355H4.10544C3.7565 21.355 3.47365 21.0721 3.47365 20.7232V9.4494C3.47365 9.10046 3.7565 8.81761 4.10544 8.81761H6.79483C7.14377 8.81761 7.42662 9.10046 7.42662 9.4494V20.7232ZM5.45014 7.75489C4.0391 7.75489 2.8952 6.61099 2.8952 5.19996C2.8952 3.78892 4.0391 2.64503 5.45014 2.64503C6.86117 2.64503 8.00507 3.78892 8.00507 5.19996C8.00507 6.61099 6.86124 7.75489 5.45014 7.75489ZM21.4813 20.7741C21.4813 21.0949 21.2212 21.355 20.9004 21.355H18.0145C17.6937 21.355 17.4335 21.0949 17.4335 20.7741V15.486C17.4335 14.6972 17.6649 12.0292 15.372 12.0292C13.5934 12.0292 13.2327 13.8553 13.1602 14.6749V20.7741C13.1602 21.0949 12.9002 21.355 12.5793 21.355H9.78817C9.46737 21.355 9.20727 21.0949 9.20727 20.7741V9.39851C9.20727 9.07772 9.46737 8.81761 9.78817 8.81761H12.5793C12.9001 8.81761 13.1602 9.07772 13.1602 9.39851V10.3821C13.8197 9.39236 14.7998 8.62844 16.8866 8.62844C21.5077 8.62844 21.4813 12.9457 21.4813 15.3178V20.7741Z" fill="#2E6BE6"/>
            </svg>
            </a>
            <a href="https://github.com/kokokostya" alt="GitHub">
              <svg className="hover:opacity-80 transition-all" width="24" height="24"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 0C5.37 0 0 5.37 0 12C0 17.31 3.435 21.795 8.205 23.385C8.805 23.49 9.03 23.13 9.03 22.815C9.03 22.53 9.015 21.585 9.015 20.58C6 21.135 5.22 19.845 4.98 19.17C4.845 18.825 4.26 17.76 3.75 17.475C3.33 17.25 2.73 16.695 3.735 16.68C4.68 16.665 5.355 17.55 5.58 17.91C6.66 19.725 8.385 19.215 9.075 18.9C9.18 18.12 9.495 17.595 9.84 17.295C7.17 16.995 4.38 15.96 4.38 11.37C4.38 10.065 4.845 8.985 5.61 8.145C5.49 7.845 5.07 6.615 5.73 4.965C5.73 4.965 6.735 4.65 9.03 6.195C9.99 5.925 11.01 5.79 12.03 5.79C13.05 5.79 14.07 5.925 15.03 6.195C17.325 4.635 18.33 4.965 18.33 4.965C18.99 6.615 18.57 7.845 18.45 8.145C19.215 8.985 19.68 10.05 19.68 11.37C19.68 15.975 16.875 16.995 14.205 17.295C14.64 17.67 15.015 18.39 15.015 19.515C15.015 21.12 15 22.41 15 22.815C15 23.13 15.225 23.505 15.825 23.385C18.2076 22.5814 20.278 21.0505 21.7446 19.008C23.2112 16.9656 24 14.5145 24 12C24 5.37 18.63 0 12 0Z" fill="black"/>
              </svg>
            </a>
            <a className="px-4 py-2 rounded-md bg-blue-600 hover:opacity-90 text-white transition-all flex items-center gap-2" href="/Cherepovskyi.pdf" target="_blank" rel="noreferrer">
              <StyledComponents.NewTab /> CV.pdf
            </a>
          </div>
        </header>

        <nav className="px-4 -mx-4 sm:px-8 lg:px-0 py-4 sm:-mx-8 mb-2 lg:mx-0 lg:mb-8 sticky z-100 top-0 lg:float-left backdrop-blur-md">
          <ul className="flex lg:flex-col gap-6 text-xl 2xl:text-2xl">
            {
              data.allMdx.nodes.map(node => (
                <li key={node.id} className="">
                  {
                    <Link to={`/${node.parent.name === "index" ? "" : node.parent.name}`} className={location.pathname !== `/${node.parent.name === "index" ? "" : node.parent.name + "/"}` &&  "text-blue-600 border-b border-blue-200 hover:border-blue-600 transition-all"}>
                      {node.frontmatter.title}
                    </Link>
                  }
                </li>
              ))
            }
            <StyledComponents.GoToTop />
          </ul>
        </nav>

        <main className="pt-3 lg:ml-50 xl:mx-50 2xl:mx-60 mb-10 flex flex-col gap-6 lg:gap-8">
          { children }
        </main>

        <footer className="lg:ml-50 xl:mx-50 2xl:mx-60 text-sm text-gray-400">
          <p>{ new Date().getFullYear() }</p>
          <p className="mb-6">Built with <a className="border-b border-gray-200 hover:border-gray-400 transition-all" href="https://www.gatsbyjs.com/">Gatsby</a> and <a className="border-b border-gray-200 hover:border-gray-400 transition-all" href="https://tailwindcss.com/">Tailwind CSS</a>.</p>
          <p>What is this? A text for ants?</p>
        </footer>
      </div>
    </MDXProvider>
  )
}